import { useTranslation } from 'react-i18next';

import { ScrollArea, Heading, Paragraph, Button } from '@app/shared/ui/atoms/Common';
import { openTelegramChannel, telegramVibrate } from '@app/shared/utils/common';
import { pandaBroom } from '@app/assets';

interface ServerErrorPageProps {
  onBackBtnClick?: () => void;
  onRefreshPageBtnClick?: () => void;
}

export default function ServerErrorPage({ onRefreshPageBtnClick }: ServerErrorPageProps) {
  const { t } = useTranslation();

  const handleSupportClick = () => {
    telegramVibrate();
    openTelegramChannel('all_pandas_are_here');
  };

  return (
    <ScrollArea>
      <div className="flex h-full flex-col items-center justify-center">
        <img src={pandaBroom} alt="panda-error" className="relative w-[200px]" />
        <div className="-mt-4 flex w-[calc(100%-10px)] max-w-[470px] flex-col items-center gap-[18px] rounded-[10px] bg-[#2e2d32d6] px-2.5 py-4">
          <Heading level={6} className="text-center text-foreground">
            {t('server_error.title')}
          </Heading>
          <Paragraph className="whitespace-pre-line text-center text-xs text-foreground">
            {t('server_error.description')}
          </Paragraph>
          {onRefreshPageBtnClick && (
            <Button size="sm" className="w-[215px]" onClick={onRefreshPageBtnClick}>
              {t('server_error.refresh_page')}
            </Button>
          )}
          <Button size="sm" className="w-[215px]" onClick={handleSupportClick}>
            {t('server_error.tech_support')}
          </Button>
        </div>
      </div>
    </ScrollArea>
  );
}
